import { sendEvent } from '../../../../utils/sendEvent';
import { selectIsAuctionSelected } from '../../../../selectors/auction';
import { IAppState } from '../../../../../AppModulesWrapper';
import {
  selectIsServicesEnabled,
  selectPlacingMoneySource,
  selectPublicationTokens,
} from '../../../../selectors/publishTerms';
import { TCheckServiceResult } from '../../../../services/checkService';
import { selectTermsDurationInDays } from '../../../../selectors/termsDurations';
import { selectIsAutoProlongChecked } from '../../../../selectors/checkoutInfo';
import { selectRecommendedPackages } from '../../../../reducers/v2/recommendedPackages/selectors';

export const sendCheckServiceEvent = (state: IAppState, response: TCheckServiceResult) => {
  const isAuctionSelected = selectIsAuctionSelected(state);
  const isServicesEnabled = selectIsServicesEnabled(state);
  const recommendedPackages = selectRecommendedPackages(state);
  const termsDurations = selectTermsDurationInDays(state);
  const moneySource = selectPlacingMoneySource(state);
  const publicationTokens = selectPublicationTokens(state);
  const isAutoprolongChecked = selectIsAutoProlongChecked(state);

  sendEvent('service-picker-widget/check-service', {
    response,
    isAuctionSelected,
    isServicesEnabled,
    recommendedPackages,
    termsDurations,
    moneySource,
    calltracking: state.servicePickerWidget.calltracking,
    publishTerms: state.servicePickerWidget.publishTerms,
    publicationTokens,
    isAutoprolongChecked,
  });
};
